const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case "table.public_deliveries/SET_TABLE_PARAMS":
            return {
                ...state,
                ...action.params
            };
        case "table.public_deliveries/LIST_PUBLIC_DELIVERIES_SUCCESS":
            return {
                ...state,
                data: action.response.data,
                filters: action.response.filters,
                ...action.response.pagination
            };
        default:
            return state;
    }
}
